/* global axios */
import ApiClient from './ApiClient';

class ContactVisibilityApi extends ApiClient {
  constructor() {
    super('contact_visibility', { accountScoped: true });
  }

  get() {
    return axios.get(`${this.url}`);
  }

  update(data) {
    return axios.put(`${this.url}`, data);
  }
}

export default new ContactVisibilityApi();
